import { useCallback, useEffect, useState } from 'react'

export default function StatusRibbon() {
  const [status, setStatus] = useState<'UP' | 'DOWN' | 'UNKNOWN'>('UNKNOWN')
  const [bridge, setBridge] = useState<'UP' | 'DOWN' | 'UNKNOWN'>('UNKNOWN')
  const [info, setInfo] = useState<any>(null)
  const [open, setOpen] = useState(false)
  const [offline, setOffline] = useState<boolean>(typeof navigator !== 'undefined' ? !navigator.onLine : false)
  const base = (import.meta as any).env?.VITE_API_BASE_URL?.replace(/\/$/, '') || ''

  const poll = useCallback(async () => {
    try {
      const res = await fetch(`${base}/actuator/health`)
      if (!res.ok) throw new Error('bad status')
      const data = await res.json()
      setStatus(data?.status === 'UP' ? 'UP' : 'DOWN')
    } catch {
      setStatus('DOWN')
    }
  }, [base])
  const pollBridge = useCallback(async () => {
    try {
      const res = await fetch(`${base}/api/bridge-ping`)
      if (!res.ok) throw new Error('bad status')
      setBridge('UP')
    } catch {
      setBridge('DOWN')
    }
  }, [base])
  const pollInfo = useCallback(async () => {
    try {
      const res = await fetch(`${base}/actuator/info`)
      if (!res.ok) return
      const data = await res.json()
      setInfo(data)
    } catch (error) {
      console.warn('Failed to fetch actuator info', error)
    }
  }, [base])

  useEffect(() => {
    poll(); pollBridge(); pollInfo()
    const id = setInterval(() => { poll(); pollBridge(); pollInfo() }, 10000)
    return () => clearInterval(id)
  }, [poll, pollBridge, pollInfo])

  useEffect(() => {
    const on = () => setOffline(false)
    const off = () => setOffline(true)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off) }
  }, [])

  const color = status === 'UP' ? 'bg-green-600' : status === 'DOWN' ? 'bg-red-600' : 'bg-gray-500'
  const label = status === 'UNKNOWN' ? 'unknown' : status.toLowerCase()

  const version = info?.build?.version || info?.git?.build?.version || 'n/a'
  const sha = info?.git?.commit?.id?.substring(0, 8) || info?.git?.commit?.id?.abbrev || 'n/a'

  return (
    <div data-testid="status-ribbon" className={`${color} text-white text-xs px-3 py-1 flex items-center gap-3 flex-wrap`} role="status" aria-live="polite">
      <span>Health: {label}</span>
      <span>| Bridge: {bridge === 'UNKNOWN' ? 'unknown' : bridge.toLowerCase()}</span>
      {offline && <span className="ml-2 bg-black/20 px-2 py-0.5 rounded">offline</span>}
      <button className="underline decoration-white/50" onClick={() => setOpen(v => !v)}>{open ? 'hide' : 'details'}</button>
      {open && (
        <span className="opacity-90">version: {version} • git: {sha}</span>
      )}
    </div>
  )
}
